<template>
    <BreadCrumb PageTitle="Liste des types de container" />
    <ListeTypeContainer />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeTypeContainer from "@/components/TypeContainer/ListeTypeContainer.vue";

export default defineComponent({
    name: "ListeTypeContainerPage",
    components: {
        BreadCrumb,
         ListeTypeContainer,
    },
});
</script>